export const crmSettingsArticle = {
  title: 'Customer CRM: Settings & Team',
  slug: 'crm-settings-team',
  content: `Customer CRM: Settings & Team

Use the Settings tab to manage workspace configuration and access.

1) Workspace settings
- Update CRM defaults and preferences from the Settings tab.

2) Team management
- Add or remove team members.
- Assign permissions so the right people can manage contacts, deals, and campaigns.
`,
};
